import React from 'react';

import { DataContext } from '@/context/data';

interface Props {
  readonly data: any;
}

export const DataProvider: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { data, children } = props;
  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
};
